import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "host-environment"
    }}>{`Host Environment`}</h1>
    <p>{`Sometimes it's necessary to find out the host environment where a plugin or script is running. You can find a range of information such as the host OS, locale, home folder, installed application version, etc, by using UXP APIs.`}</p>
    <h2 {...{
      "id": "system-requirements"
    }}>{`System requirements`}</h2>
    <p>{`Please make sure your local environment uses the following application versions before proceeding.`}</p>
    <ul>
      <li parentName="ul">{`InDesign v18.5 or higher`}</li>
      <li parentName="ul">{`UDT v1.9.0 or higher`}</li>
      <li parentName="ul">{`Manifest version v5 or higher`}</li>
    </ul>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <CodeBlock slots="heading, code" repeat="2" languages="JavaScript,text" mdxType="CodeBlock" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async function foo() {
    const { host, versions } = require('uxp');
    const osInfo = require('os');

    console.log(\`System information: \${osInfo.platform()} v\${osInfo.release()}\`);
    console.log(\`Application: \${host.name} v\${host.version} powered by \${versions.uxp}\`);
}
`}</code></pre>
    <h4 {...{
      "id": "output"
    }}>{`Output`}</h4>
    <pre><code parentName="pre" {...{}}>{`System information: darwin v21.1.0
Application: InDesign v18.5.0 powered by uxp-7.1.0
`}</code></pre>
    <h2 {...{
      "id": "reference-material"
    }}>{`Reference material`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Modules/uxp/Host%20Information/Host/"
        }}>{`Host`}</a>{` APIs`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Modules/uxp/Versions/Versions/"
        }}>{`Versions`}</a>{` APIs`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Modules/os/OS/"
        }}>{`OS`}</a>{` APIs`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      